module.exports = __webpack_public_path__ + "img/fashion_75.c76be2a9.jpg";